export default __webpack_public_path__ + "static/media/queshengye-timu.3666a0b1.png";